/* eslint-disable react/prop-types */
import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

import Hero from './patterns/Hero/Hero';
import NuBenefits from './patterns/NuBenefits/NuBenefits';
import MastercardBenefits from './patterns/MastercardBenefits/MastercardBenefits';
import Mastercard from './patterns/Mastercard';
import ClosingBlock from './patterns/ClosingBlock';

const Benefits = props => {
  const { benefitsNu, benefitsMastercard, categories } = props;

  return (
    <ParallaxProvider>
      <Hero />
      <NuBenefits partnersList={benefitsNu} />
      <MastercardBenefits
        partnersList={benefitsMastercard}
        categories={categories}
      />
      <Mastercard />
      <ClosingBlock />
    </ParallaxProvider>
  );
};

export default Benefits;
